(function () {
  var MOBILE_MAX = 767;
  var promo = document.querySelector(".header__promo");
  var track = promo && promo.querySelector(".header__promo-track");
  var sourceList = track && track.querySelector(".header__promo-list");

  if (!promo || !track || !sourceList) {
    return;
  }

  var sourceHTML = sourceList.innerHTML;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function resetMarquee() {
    while (track.children.length > 1) {
      track.removeChild(track.lastElementChild);
    }

    sourceList.innerHTML = sourceHTML;
    promo.classList.remove("header__promo--marquee");
  }

  function buildMarquee() {
    resetMarquee();

    if (!isMobile()) {
      return;
    }

    promo.classList.add("header__promo--marquee");

    while (sourceList.scrollWidth < window.innerWidth) {
      sourceList.insertAdjacentHTML("beforeend", sourceHTML);
    }

    var clone = sourceList.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);
  }

  buildMarquee();
  window.addEventListener("resize", buildMarquee);
})();
